module.exports = __webpack_public_path__ + "img/datacom.faf0659c.png";